import { ArrowUpRight, Instagram, MessageCircle, Phone } from "lucide-react";
import { COMPANY, OWNERS } from "@/lib/company";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#050B14] border-t border-[#1E293B] pt-24 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Massive logo line */}
        <div className="border-b border-[#1E293B] pb-12 mb-12">
          <div className="text-7xl md:text-[9rem] lg:text-[12rem] font-bold tracking-tighter leading-none text-white">
            Dea<span className="text-[#FF5A1F]">.</span>
          </div>
          <div className="mt-2 text-sm tracking-[0.3em] uppercase text-slate-500">
            Impresa Edile · Pavia & Milano
          </div>
        </div>

        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-4">
            <p className="text-slate-400 leading-relaxed max-w-sm">
              Costruiamo, ristrutturiamo e finiamo opere edili tra Pavia e
              Milano. Squadra interna, mezzi propri, controllo totale del
              cantiere.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href={COMPANY.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram Dea srl"
                data-testid="social-instagram"
                className="w-10 h-10 border border-slate-700 hover:border-[#FF5A1F] hover:text-[#FF5A1F] text-slate-400 flex items-center justify-center transition-colors"
              >
                <Instagram size={16} />
              </a>
              <a
                href="https://wa.me/393393015941"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp Dea srl"
                data-testid="social-whatsapp"
                className="w-10 h-10 border border-slate-700 hover:border-[#25D366] hover:text-[#25D366] text-slate-400 flex items-center justify-center transition-colors"
              >
                <MessageCircle size={16} />
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs tracking-[0.25em] uppercase text-slate-500 mb-5">
              Navigazione
            </div>
            <ul className="space-y-3 text-slate-300">
              <li>
                <a href="#servizi" className="hover:text-white">
                  Servizi
                </a>
              </li>
              <li>
                <a href="#azienda" className="hover:text-white">
                  L'Azienda
                </a>
              </li>
              <li>
                <a href="#progetti" className="hover:text-white">
                  Progetti
                </a>
              </li>
              <li>
                <a href="#contatti" className="hover:text-white">
                  Contatti
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.25em] uppercase text-slate-500 mb-5">
              Servizi
            </div>
            <ul className="space-y-3 text-slate-300">
              <li>Facciate condominiali</li>
              <li>Cappotto termico</li>
              <li>Finiture d'interni</li>
              <li>Ristrutturazioni</li>
              <li>Carpenteria & Arredo</li>
              <li>Impianti Fotovoltaici</li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs tracking-[0.25em] uppercase text-slate-500 mb-5">
              Contatti
            </div>
            <ul className="space-y-3 text-slate-300 text-sm">
              {OWNERS.map((o) => (
                <li key={o.phone}>
                  <a
                    href={`tel:${o.phoneHref}`}
                    className="hover:text-[#FF5A1F] flex items-center gap-2"
                  >
                    <Phone size={12} className="text-[#FF5A1F]" />
                    <span className="font-semibold">
                      {o.name.split(" ")[0]}:
                    </span>{" "}
                    {o.phone}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="hover:text-[#FF5A1F]"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li>{COMPANY.area}</li>
              <li className="pt-2">
                <a
                  href="#preventivo"
                  className="inline-flex items-center gap-2 text-[#FF5A1F] font-semibold link-underline"
                >
                  Richiedi preventivo <ArrowUpRight size={14} />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1E293B] pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-slate-500">
          <div>
            © {year} Dea s.r.l. — Tutti i diritti riservati. · {COMPANY.vatNumber} ·{" "}
            {COMPANY.rea}
          </div>
          <div className="flex gap-6">
            <a href="/privacy-policy" data-testid="footer-privacy" className="hover:text-white">
              Privacy Policy
            </a>
            <a href="/cookie-policy" data-testid="footer-cookie" className="hover:text-white">
              Cookie Policy
            </a>
            <a href="/admin" className="hover:text-white" data-testid="admin-link">
              Area Riservata
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
